export default {
  common: {
    confirm: 'confirm',
    cancel: 'cancel'
  }
}
